import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ColumnDirective, ColumnsDirective,
    GridComponent, Inject, Sort, Resize,
    Toolbar, ExcelExport, PdfExport, ColumnChooser
} from '@syncfusion/ej2-react-grids';
import { AggregatesDirective, Aggregate, AggregateColumnsDirective, AggregateDirective, AggregateColumnDirective } from '@syncfusion/ej2-react-grids';

import { MultiSelectComponent, CheckBoxSelection, Inject as InjectDrop } from '@syncfusion/ej2-react-dropdowns';

import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "./../../../store/actions/uiAction";
import { logReportService } from './../../../services/logReportService';
import ComboHotelSala from "./../../../components/combo-hotel-sala/combo-hotel-sala";
import ComboPaises from "./../../../components/combo-paises/combo-paises";

const ProductionCountry = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);
    const [countriesData, setCountriesData] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel, idPais } = useSelector(state => state.user.param);
    let grid = null;

    let mulObjcountries = [];
    let mulObjProgramas = null;
    const toolbarOptions = ['ColumnChooser'];

    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const checkFields = { text: 'Name', value: 'Code' };


    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, eject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }

                    resolve(res);
                }
            })
        })

    }

    const getCountriesData = () => {
        getOptionData('/catalog/paises')
            .then((response) => {
                setCountriesData(response);
            })
    }

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            });
    };

    const handleViewButton = () => {
        getProductionCountryReport();
    }

    const getProductionCountryReport = () => {

        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');;
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');;

        const idPais = (mulObjcountries != null && mulObjcountries.value.length > 0) ? mulObjcountries.value.map(String).toString() : "0";

        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
      

        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                setNamePrograma(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        getDataReport(`/reports/country-production/${date1}/${date2}/${idSaleRoom}/${idHotel}/${idPais}/${programas}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('Production Country', user);
            }
        })
    }

    // Reporte
    const handleButtonOption = (opt) => {
        if (grid && opt.target.innerText === 'Export to excel') {
            export2Excel();
        } else {
            if (grid && opt.target.innerText === 'Export to pdf') {
                grid.pdfExport();
            }
        }
    }

    const export2Excel = () => {
        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();

        const excelExportProperties = {
            fileName: t('menusidebar.label.production-country') + ".xlsx",
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 },
            },
            header: {
                headerRows: 6,
                rows: [
                    { cells: [{ colSpan: 4, value: "LVC KCS " + t('menusidebar.label.production-country'), style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "SALES ROOM: " + NameSala["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "HOTELS: " + NameHotel["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                    { cells: [{ colSpan: 4, value: "PROGRAMS: " + NamePrograma[0]["name"], style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
                
                    { cells: [{ colSpan: 4, value: date1 + " - " + date2, style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },

                ]
            }
        }

        console.log("SALES ROOM", NameSala)
        console.log("HOTELS", NameHotel)
        console.log("date1", date1)
        console.log("date2", date2)
        console.log("excelExportProperties", excelExportProperties)

        grid.excelExport(excelExportProperties);
    }

    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    }

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else {
            if (grid && args.item.id === 'grid_pdfexport') {
                grid.pdfExport();
            }
        }
    }

    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    }

    function footerSum(props) {
        return (<span>{props.Sum}</span>);

    }
    function footerAverage(props) {
        return (<span>{props.Average}</span>);
    }

    function custom(props) {
        return (<span>{props.Custom}</span>);
    }

    function customAggregateFnAvails() {
        var gridData = grid.dataSource; // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {

            totalSum1 = totalSum1 + gridData[i]['avails'];
            totalSum2 = totalSum2 + gridData[i]['arrivals'];
        }
        let average = 0;

        totalSum2 == 0 ? average = totalSum2 : average = totalSum1 / totalSum2;

        // return the calculated value

        return average;

    }

    function customAggregateFnBk() {
        var gridData = grid.dataSource; // gridObject.dataSource returns entire data if the grid having local dataSource

        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset

        for (var i = 0; i < gridData.length; i++) {

            totalSum1 = totalSum1 + gridData[i]['bk'];
            totalSum2 = totalSum2 + gridData[i]['avails'];
        }

        let average = 0;

        totalSum2 == 0 ? average = totalSum2 : average = totalSum1 / totalSum2;
        // return the calculated value
        return average;

    }

    function customAggregateFnPenetracionFK() {
        var gridData = grid.dataSource; // gridObject.dataSource returns entire data if the grid having local dataSource

        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset

        for (var i = 0; i < gridData.length; i++) {

            totalSum1 = totalSum1 + gridData[i]['tShows'];
            totalSum2 = totalSum2 + gridData[i]['avails'];
        }

        let average = 0;
        console.log("totalSum1", totalSum1);
        totalSum1 == 0 ? average = totalSum1 : average = totalSum1 / totalSum2;
        // return the calculated value
        return average;

    }

    function customAggregateFnSh() {
        var gridData = grid.dataSource;
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {
            totalSum1 = totalSum1 + gridData[i]['sh'];
            totalSum2 = totalSum2 + gridData[i]['bk'];
        }

        let average = 0;

        totalSum2 == 0 ? average = totalSum2 : average = totalSum1 / totalSum2;
        // return the calculated value

        return average;

    }

    function customAggregateFnCl() {

        var gridData = grid.dataSource;
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {
            totalSum1 = totalSum1 + gridData[i]['cancelled'];
            totalSum2 = totalSum2 + gridData[i]['totalSales'];
        }

        let average = 0;
        totalSum2 == 0 ? average = totalSum2 : average = totalSum1 / totalSum2;
        // return the calculated value

        return average;

    }

    function customAggregateFnEff() {

        var gridData = grid.dataSource;
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {
            totalSum1 = totalSum1 + gridData[i]['totalVolume'];
            totalSum2 = totalSum2 + gridData[i]['tShows'];
        }

        let eff = 0;

        totalSum2 == 0 ? eff = 0 : eff = totalSum1 / totalSum2;


        // return the calculated value

        return eff;

    }

    function customAggregateFnClo() {

        var gridData = grid.dataSource;
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {
            totalSum1 = totalSum1 + gridData[i]['totalSales'];
            totalSum2 = totalSum2 + gridData[i]['tShows'];
        }

        let closingPercent = 0;

        totalSum2 == 0 ? closingPercent = 0 : closingPercent = totalSum1 / totalSum2;


        // return the calculated value

        return closingPercent;

    }

    function customAggregateFnAvg() {

        var gridData = grid.dataSource;
        // gridObject.dataSource returns entire data if the grid having local dataSource
        var totalSum1 = 0;
        var totalSum2 = 0;
        // do your calculation as you want with the entire dataset
        for (var i = 0; i < gridData.length; i++) {
            totalSum1 = totalSum1 + gridData[i]['totalVolume'];
            totalSum2 = totalSum2 + gridData[i]['totalSales'];
        }

        let avg = 0;

        totalSum2 == 0 ? avg = 0 : avg = totalSum1 / totalSum2;

        // return the calculated value

        return avg;

    }








    // Fin Reporte

    useEffect(() => {
        getCountriesData();
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.production-country')));
    }, [])

    return (
        <div className="container-fluid">

            <ComboHotelSala />
    
            <div className="row   col-md-12">
                <div className="col-md-6 form-group">
                    <label>Programas:</label>
                    <MultiSelectComponent 
                        id="Programa" 
                        ref={(scope) => { mulObjProgramas = scope; }} 
                        dataSource={programasData}
                        fields={checkFields} 
                        placeholder="Seleccionar programas" 
                        mode="CheckBox" 
                        showSelectAll={true}
                        showDropDownIcon={true} 
                        filterBarPlaceholder="Buscar programa" 
                        popupHeight="350px" 
                        value={[]}>
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
                <div className="col-md-6 form-group">
                    <label>Countries:</label>
                    <MultiSelectComponent id="checkbox" ref={(scope) => { mulObjcountries = scope; }} dataSource={countriesData}
                        fields={checkFields} placeholder="Select type" mode="CheckBox" showSelectAll={true}
                        showDropDownIcon={true} filterBarPlaceholder="Search estatus" popupHeight="350px" value={[]}              >
                        <InjectDrop services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
            </div>

            <div className="row   col-md-12">

                <div className="col-md-3 form-group">
                    <label >Date start:</label>
                    <SemanticDatepicker className="col-md-12" name="dateStart" value={dateStart} onChange={onChangeDateStart} />

                </div>
                <div className="col-md-3  form-group ">

                    <label >Date end:</label>
                    <SemanticDatepicker className="col-md-12" name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />

                </div>
                <div className="col-md-6  form-group">

                    <Button primary onClick={handleViewButton}>View Report</Button>
                    <Button positive onClick={handleExport2Excel}>Export Report</Button>
                    {/*<Button.Group className="col-md-3" color='orange'>
                        <Button onClick={handleExport2Excel}>Print Report</Button>
                        <Dropdown
                            className='button icon'
                            floating
                            options={options}
                            onChange={handleButtonOption}
                            trigger={<></>}
                        />
                        </Button.Group>*/}


                </div>
            </div>
            <div>
                <GridComponent id="grid" height='100%' width='auto'
                    dataSource={rowData}
                    allowSorting={true}
                    allowResizing={true}
                    allowExcelExport={true}
                    allowPdfExport={true}
                    showColumnChooser={true}
                    toolbar={toolbarOptions}
                    toolbarClick={handleToolbarClick}
                    dataBound={dataBound}
                    ref={g => grid = g}
                >
                    <Inject services={[Sort, Toolbar, Resize, ExcelExport, PdfExport, Aggregate, ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='rownum' headerText="Num" minWidth='5' textAlign="Right" />
                        <ColumnDirective field='pais' headerText="Pais" Width='40' textAlign="Left" />
                        <ColumnDirective field='arrivals' headerText="Arrival" minWidth='10' textAlign="Right" format="N2" />
                        <ColumnDirective field='avails' headerText="Avails" minWidth='10' textAlign="Right" format="N2" />
                        <ColumnDirective field='perAvails' headerText="A%" minWidth='20' textAlign="Left" format="P2" />
                        <ColumnDirective field='info' headerText="Info" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='bk' headerText="Bk" minWidth='10' textAlign="Right" />
                        <ColumnDirective field='bkFactor' headerText="Bk%" minWidth='20' textAlign="Left" format="P2" />
                        <ColumnDirective field='sh' headerText="Sh" minWidth='10' textAlign="Right" />
                        <ColumnDirective field='shFactor' headerText="Sh%" minWidth='20' textAlign="Left" format="P2" />
                        <ColumnDirective field='dir' headerText="Dir" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='tShows' headerText="TShows" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='penetracion' headerText="Penetracion%" minWidth='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='qs' headerText="Qs" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='q1s' headerText="Q1s" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='qfs' headerText="Qfs" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='nqs' headerText="Nqs" minWidth='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='nqfs' headerText="Nqfs" minWidth='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='ct' headerText="CTs" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='safe' headerText="SAFE" width='20' textAlign="Right" format="N2" />
                        <ColumnDirective field='sales' headerText="Sales" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='processable' headerText="Processable" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='oop' headerText="OOP" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='oopVolume' headerText="OOPVolume" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='cancelled' headerText="Cancelled" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='cancelledVolume' headerText="Cancelled#" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='cancelPercent' headerText="C%" minWidth='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='totalSales' headerText="Total Sales" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='totalVolume' headerText="Total Volume" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='eff' headerText="Eff" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='closingPercent' headerText="CL%" minWidth='20' textAlign="Right" format="P2" />
                        <ColumnDirective field='avg' headerText="AVG" minWidth='20' textAlign="Right" format="C2" />
                        <ColumnDirective field='pending' headerText="Pending" minWidth='20' textAlign="Right" />
                        <ColumnDirective field='pendingVolume' headerText="Pending#" minWidth='20' textAlign="Right" format="N2" />
                    </ColumnsDirective>
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                <AggregateColumnDirective field='arrivals' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='avails' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='perAvails' type='Custom' format="P2" customAggregate={customAggregateFnAvails} />
                                <AggregateColumnDirective field='info' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='bk' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='bkFactor' type='Custom' format='P2' customAggregate={customAggregateFnBk} />
                                <AggregateColumnDirective field='sh' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='shFactor' type='Custom' format='P2' customAggregate={customAggregateFnSh} />
                                <AggregateColumnDirective field='dir' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='tShows' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='penetracion' type='Custom' format='P2' customAggregate={customAggregateFnPenetracionFK} />
                                <AggregateColumnDirective field='qs' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='q1s' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='nQs' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='ct' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='safe' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='sales' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='processable' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='oop' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='oopVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='cancelled' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='cancelledVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='cancelPercent' type='Custom' format='P2' customAggregate={customAggregateFnCl} />
                                <AggregateColumnDirective field='totalSales' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='totalVolume' type='Sum' format="C2" customAggregate={footerSum} />
                                <AggregateColumnDirective field='eff' type='Custom' format="C2" customAggregate={customAggregateFnEff} />
                                <AggregateColumnDirective field='closingPercent' type='Custom' format='P2' customAggregate={customAggregateFnClo} />
                                <AggregateColumnDirective field='avg' type='Custom' format="C2" customAggregate={customAggregateFnAvg} />
                                <AggregateColumnDirective field='pending' type='Sum' customAggregate={footerSum} />
                                <AggregateColumnDirective field='pendingVolume' type='Sum' format="C2" customAggregate={footerSum} />
                            </AggregateColumnsDirective>
                        </AggregateDirective>
                    </AggregatesDirective>
                </GridComponent>
            </div>
        </div>
    );
}

export default ProductionCountry;
